import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import MymeTypeIcon from '../../../MymeTypeIcon';
import { Button, Collapsible } from 'ncoded-component-library';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import {
  getIsNodeFile,
  getIsNodeFolder,
  getNodeMimeType,
  sortDataRoomNodes,
} from 'utils';
import ChevrondownIcon from 'icons/Chevrondown.icon';
import useCallbackRef from 'hooks/useCallbackRef';
import PlusIcon from 'icons/Plus.icon';
import { CollapsibleRef } from 'ncoded-component-library/build/components/molecules/Collapsible/Collapsible.component';

import './FileInfo.styles.scss';

type FileInfoProps = {
  className?: string;
  nodes?: DataRoomNode[];
  onFilesReselect: () => void;
};

const FileInfo: React.FC<FileInfoProps> = (props) => {
  const { className, nodes, onFilesReselect } = props;

  const classes = classNames('shareable-file-info', className);

  const [collapse, collapseRef] = useCallbackRef<CollapsibleRef>();

  const { t } = useTranslation();

  const sortedNodes = useMemo(() => sortDataRoomNodes(nodes), [nodes]);

  const selectedLabel = useMemo(() => {
    if (nodes.every(getIsNodeFile)) return 'viewFiles';

    if (nodes.every(getIsNodeFolder)) return 'viewFolders';

    return 'viewItems';
  }, [nodes]);

  return (
    <Collapsible
      ref={collapseRef}
      className={classes}
      trigger={
        <p className={classNames('trigger', { open: collapse?.open })}>
          {t(selectedLabel, { count: nodes.length })} <ChevrondownIcon />
        </p>
      }
    >
      <>
        <ul>
          {sortedNodes.map(({ _id, name, ...rest }) => (
            <li key={_id}>
              <MymeTypeIcon mimeType={getNodeMimeType(rest)} />
              {name}
            </li>
          ))}
        </ul>
        <Button variant="link" icon={PlusIcon} onClick={onFilesReselect}>
          {t('addMoreFiles')}
        </Button>
      </>
    </Collapsible>
  );
};

export default FileInfo;
